"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.iconList = void 0;
exports.iconList = [
    'semantic-accessoires',
    'semantic-add',
    'semantic-air-filter',
    'semantic-arrow-right',
    'semantic-back',
    'semantic-benefit-finance',
    'semantic-brake-fluid',
    'semantic-briefcase',
    'semantic-brochure',
    'semantic-calculator',
    'semantic-calendar',
    'semantic-car-door',
    'semantic-car-handover',
    'semantic-car-return',
    'semantic-car-seat',
    'semantic-car-side',
    'semantic-car-tow-bar',
    'semantic-car-value',
    'semantic-car',
    'semantic-chat',
    'semantic-checkmark',
    'semantic-clock',
    'semantic-close',
    'semantic-collapse',
    'semantic-configuration-details',
    'semantic-contact',
    'semantic-cookie-settings',
    'semantic-crossed-out',
    'semantic-dealer',
    'semantic-delete',
    'semantic-details',
    'semantic-diesel',
    'semantic-download',
    'semantic-edit',
    'semantic-electric',
    'semantic-emission',
    'semantic-engine-oil',
    'semantic-engine',
    'semantic-enter-fullscreen',
    'semantic-equalsign',
    'semantic-error',
    'semantic-exit-fullscreen',
    'semantic-expand',
    'semantic-faq',
    'semantic-favorite',
    'semantic-file',
    'semantic-filter',
    'semantic-forward',
    'semantic-four-wheel-drive',
    'semantic-front-wheel-drive',
    'semantic-fs-payment',
    'semantic-fuel-natural-gas',
    'semantic-fuel',
    'semantic-gear-oil',
    'semantic-guarantee',
    'semantic-hybrid',
    'semantic-info',
    'semantic-like',
    'semantic-list',
    'semantic-location',
    'semantic-lock',
    'semantic-login',
    'semantic-mail',
    'semantic-menu',
    'semantic-minus',
    'semantic-mobility',
    'semantic-more',
    'semantic-news',
    'semantic-notification',
    'semantic-offers',
    'semantic-pause',
    'semantic-performance',
    'semantic-petrol',
    'semantic-phone',
    'semantic-play',
    'semantic-plus',
    'semantic-premium-l',
    'semantic-premium-m',
    'semantic-premium-s',
    'semantic-print',
    'semantic-quality',
    'semantic-reload',
    'semantic-safety-check',
    'semantic-save-cloud',
    'semantic-save-local',
    'semantic-search',
    'semantic-service',
    'semantic-settings',
    'semantic-smartphone',
    'semantic-social-facebook',
    'semantic-social-instagram',
    'semantic-social-linkedin',
    'semantic-social-pinterest',
    'semantic-social-rss',
    'semantic-social-twitter',
    'semantic-social-vimeo',
    'semantic-social-xing',
    'semantic-social-youtube',
    'semantic-sort-asc',
    'semantic-sort-desc',
    'semantic-spark-plug',
    'semantic-steering-wheel',
    'semantic-stop',
    'semantic-success',
    'semantic-switch',
    'semantic-transmission-automatic',
    'semantic-transmission-manual',
    'semantic-up',
    'semantic-upload',
    'semantic-user',
    'semantic-volume-down',
    'semantic-volume-up',
    'semantic-volume',
    'semantic-warning',
    'semantic-zoom-in',
    'semantic-zoom-out',
    'account-detail',
    'address-book',
    'air-filter',
    'arrow-down',
    'arrow-left',
    'arrow-right',
    'arrow-up',
    'arrow-up-and-down',
    'atm',
    'atm-pesosign',
    'atm-randsign',
    'bankcard',
    'bankey',
    'bankey-appli',
    'bell',
    'bestprice-pesosign',
    'bestprice-randsign',
    'bin',
    'bookmark',
    'brake-fluid',
    'branch',
    'briefcase',
    'bubble-circles',
    'burger',
    'calculator',
    'calculator-03',
    'calendar',
    'calendar-circle-arrow-down',
    'calendar-circle-checkmark',
    'calendar-finger',
    'calendar-pesosign',
    'calendar-randsign',
    'caption',
    'captions-closed-off',
    'captions-closed-on',
    'car',
    'car-calendar',
    'car-circle-eurosign',
    'car-circle-pesosign',
    'car-circle-poundsign',
    'car-circle-randsign',
    'car-configurator',
    'car-door',
    'car-key',
    'car-lightning-circle-eurosign',
    'car-seat',
    'car-side',
    'car-three-stars',
    'car-tow-bar',
    'cards-car',
    'cards-visa',
    'cars-right-left',
    'charging-station',
    'checkmark',
    'checkmark-circle',
    'checkmark-outline',
    'chevron-down',
    'chevron-left',
    'chevron-right',
    'chevron-up',
    'chip',
    'circle-ellipsis',
    'clock',
    'clock-circle-arrow-down',
    'clock-phone-24',
    'cloud-lightning',
    'coincs-circle-percentage',
    'coins-circle-arrow',
    'coins-circle-arrow-down',
    'coins-circle-arrow-down-bigcirlce',
    'coins-circle-arrows-left-right',
    'coins-circle-eurosign',
    'coins-circle-peso',
    'coins-circle-poundsign',
    'coins-circle-rand',
    'coins-label-vwfs',
    'coins-lock',
    'comments',
    'configurator',
    'court-hammer',
    'creditcard',
    'cross',
    'data-secure',
    'dealer',
    'details',
    'diesel',
    'divide',
    'doc-coins-circle-arrow-down',
    'doc-lines-circle-arrow-down',
    'doc-lines-circle-arrows',
    'doc-lines-key-chain',
    'document',
    'document-arrow',
    'document-car',
    'document-checkmark',
    'document-cross',
    'document-jpg',
    'document-lines-checkmark',
    'document-lines-pen',
    'document-pdf',
    'document-xls',
    'documents',
    'doors-double',
    'download',
    'drag-drop',
    'electricity-card',
    'electricity-plug',
    'emission',
    'engine',
    'engine-oil',
    'enter-fullscreen',
    'equalsign',
    'eurosign',
    'exclamation-mark',
    'exclamation-mark-circle',
    'exclamation-mark-triangle',
    'exit-fullscreen',
    'eye',
    'eye-crossed',
    'faq',
    'filter',
    'filter-02',
    'filter-circle-b',
    'filter-circle-n',
    'finger-arrows',
    'finger-arrows-circle-eurosign',
    'fleet',
    'flight',
    'floppy-disc',
    'four-wheel-drive',
    'front-wheel-drive',
    'gas-card',
    'gas-station',
    'gear',
    'gear-oil',
    'globe',
    'globe-car',
    'globe-visa-coins',
    'graph-scope',
    'graph-view',
    'graph-view-03',
    'graph-view-arrow-up',
    'green-electricity',
    'hand-car',
    'hand-circle-eu',
    'hand-circle-eurosign',
    'hand-circle-pesosign',
    'hand-circle-poundsign',
    'hand-circle-randsign',
    'hand-electricity-plug',
    'hand-heart',
    'hand-key',
    'hands-heart',
    'headset-lightning',
    'heart',
    'heart-filled',
    'home-charging',
    'house',
    'hybrid',
    'id-circle-checkmark',
    'info',
    'info-circle',
    'ipad-finger',
    'key-chain',
    'key-chain-circle-arrows',
    'laptop-id',
    'lightbulb',
    'list-badge-lines-1',
    'list-badge-lines-3',
    'list-badge-lines-5',
    'list-view',
    'lock',
    'lock-circle-checkmark',
    'lock-percentage',
    'logout',
    'magazine',
    'magnifying-glass',
    'mail',
    'minimize',
    'minus',
    'mobile',
    'mobile-app',
    'mobile-sms',
    'money-transfer',
    'money-transfer-arrows',
    'monitor',
    'monitor-car',
    'monitor-circle-cross',
    'monitor-circle-eurosign',
    'monitor-circle-peso',
    'monitor-circle-poundsign',
    'monitor-circle-rand',
    'monitor-graph',
    'monitor-lines-lock',
    'monitor-lines-visa',
    'monitor-peso',
    'monitor-rand',
    'natural-gas',
    'newsletter',
    'no-sound',
    'offers',
    'paintbrush',
    'pause',
    'pen',
    'pen-lines',
    'performance',
    'person-injured',
    'petrol',
    'petrol-card',
    'petrol-station',
    'phone',
    'phone-lines',
    'phone-suitcase',
    'phone-visa',
    'piggybank',
    'pin',
    'play',
    'play-circle',
    'plus',
    'printer',
    'qr-code',
    'quality',
    'quality-medal',
    'refuelnload',
    'reload',
    'repeat',
    'revoke',
    'risk-diversification-peso',
    'risk-diversification-rand',
    'safe',
    'safety-check',
    'save-cloud',
    'save-local',
    'share',
    'share-02',
    'shield-car',
    'shield-checkmark',
    'shield-checkmark-cross',
    'shield-checkmark-plus',
    'signal-car',
    'size-increase',
    'social-facebook',
    'social-instagram',
    'social-linkedin',
    'social-pinterest',
    'social-rss',
    'social-twitter',
    'social-vimeo',
    'social-xing',
    'social-youtube',
    'sound',
    'spark-plug',
    'speech-bubble-question-mark',
    'squares-finger',
    'star',
    'steering-wheel',
    'stop',
    'stop-watch',
    'suitcase',
    'suitcase-circle-percentage',
    'suitcase-lock',
    'suitcase-shield-checkmark',
    'support',
    'tire-lightbulb',
    'tire-plus',
    'train',
    'transaction-list',
    'transmission-automatic',
    'transmission-manual',
    'triangle-paragraph-sign',
    'trolley',
    'trolley-lock',
    'truck-right-bus-left',
    'two-users',
    'upload',
    'upload-xls-csv',
    'user',
    'user-circle-plussign',
    'user-logged-in-01',
    'user-logged-in-02',
    'visa-card-circle-cross',
    'visa-card-lock',
    'visa-card-shield-checkmark',
    'visa-contactless',
    'visa-prepaid',
    'wallet',
    'wheel-circle-arrows',
    'wheel-circle-directions',
    'wheel-circle-star',
    'workshop',
    'world-car',
    'world-suitcase',
];
